import React from "react";
import "./dashboard-activity.scss";
export default function DashboardActivity() {
  return <p>DashboardActivity is working!</p>;
}

